export default __webpack_public_path__ + "static/media/habano-6Closed.71d99506.jpg";